import { Box } from '@primer/react';
import { Heading } from '@upright/ui/common/generic/components/primer-custom/heading';
import { Link } from '@upright/ui/common/generic/components/primer-custom/link';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';
import { KBUrl, useOnKbLinkClick } from '@upright/ui/common/upright/kb-urls';

export const MoreInformation = () => {
  const onKbLinkClick = useOnKbLinkClick();

  return (
    <Box my={3}>
      <Heading fontSize="micro" sx={{ mb: 2 }}>
        More information
      </Heading>
      <Text>
        More information is available in the Upright Knowledge base within the following subtopics:
        <ul>
          <li>
            <Link
              onClick={() => {
                onKbLinkClick(KBUrl.METHODOLOGY_NET_IMPACT);
              }}
              href={KBUrl.METHODOLOGY_NET_IMPACT}
              indicator="color"
            >
              Upright's net impact methodology
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                onKbLinkClick(KBUrl.METRICS_NET_IMPACT);
              }}
              href={KBUrl.METRICS_NET_IMPACT}
              indicator="color"
            >
              Upright's net impact metrics
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                onKbLinkClick(KBUrl.BACKGROUND_NET_IMPACT);
              }}
              href={KBUrl.BACKGROUND_NET_IMPACT}
              indicator="color"
            >
              Why net impact is relevant
            </Link>
          </li>
        </ul>
      </Text>
    </Box>
  );
};
